import {
  GUEST_HISTORY_SEARCH_FAILURE,
  GUEST_HISTORY_SEARCH_REQUEST,
  GUEST_HISTORY_SEARCH_SUCCESS,
  GUEST_HISTORY_RESET,
} from "constants/ActionTypes"

export type GuestHistorySortOrder = "asc" | "desc"

export type GuestHistoryCompareOperator = ">" | ">=" | "<" | "<=" | "=" | "!="

export interface GuestHistoryNumericFilter {
  op: GuestHistoryCompareOperator
  value: number
}

export interface GuestHistorySearchFilters {
  search_text?: string
  guest_name?: string
  doc_number?: string
  member_code?: string
  email?: string
  telephone?: string
  nation_id?: number | string
  country_id?: number | string
  vip_id?: number | string
  birthdate?: string
  arrival?: string
  departure?: string
  stay_date?: string
  channel_id?: number | string
  company?: string
  visit_time?: GuestHistoryNumericFilter | number | string
  visit_night?: GuestHistoryNumericFilter | number | string
  carplate_no?: string
  register_id?: string
  booking_id?: string
  room_number?: string
  roomtype_id?: number | string
  rateplan_id?: number | string
}

export interface GuestHistoryPagingRequest {
  page?: number
  limit?: number
  sort_field?: string
  sort_order?: GuestHistorySortOrder
}

export interface GuestHistorySearchRequestPayload {
  filters?: GuestHistorySearchFilters
  paging?: GuestHistoryPagingRequest
  replaceFilters?: boolean
}

export interface GuestHistoryRecord {
  id: number | string
  full_name?: string | null
  nationality?: string | null
  country?: string | null
  emails?: string[] | null
  telephones?: string[] | null
  mobiles?: string[] | null
  company?: string | null
  channel?: string | null
  vip_level?: string | null
  birthdate?: string | null
  visit_count?: number | null
  visit_nights?: number | null
  last_arrival?: string | null
  last_departure?: string | null
  [key: string]: unknown
}

export interface GuestHistoryPaging {
  current: number
  limit: number
  total_rows: number
  row_count: number
  sort_field?: string
  sort_order?: GuestHistorySortOrder
}

export interface GuestHistorySearchSuccessPayload {
  items: GuestHistoryRecord[]
  paging: GuestHistoryPaging
  result_code?: string | number | null
  result_msg?: string | null
  request?: GuestHistorySearchRequestPayload
}

export interface GuestHistorySearchFailurePayload {
  message: string
  status?: number
  result_code?: string | number | null
  response?: unknown
}

export interface GuestHistorySearchRequestAction {
  type: typeof GUEST_HISTORY_SEARCH_REQUEST
  payload: GuestHistorySearchRequestPayload
}

export interface GuestHistorySearchSuccessAction {
  type: typeof GUEST_HISTORY_SEARCH_SUCCESS
  payload: GuestHistorySearchSuccessPayload
}

export interface GuestHistorySearchFailureAction {
  type: typeof GUEST_HISTORY_SEARCH_FAILURE
  payload: GuestHistorySearchFailurePayload
}

export interface GuestHistoryResetAction {
  type: typeof GUEST_HISTORY_RESET
}

export type GuestHistoryActions =
  | GuestHistorySearchRequestAction
  | GuestHistorySearchSuccessAction
  | GuestHistorySearchFailureAction
  | GuestHistoryResetAction

export const guestHistorySearchRequest = (
  payload: GuestHistorySearchRequestPayload
): GuestHistorySearchRequestAction => ({
  type: GUEST_HISTORY_SEARCH_REQUEST,
  payload,
})

export const guestHistorySearchSuccess = (
  payload: GuestHistorySearchSuccessPayload
): GuestHistorySearchSuccessAction => ({
  type: GUEST_HISTORY_SEARCH_SUCCESS,
  payload,
})

export const guestHistorySearchFailure = (
  payload: GuestHistorySearchFailurePayload
): GuestHistorySearchFailureAction => ({
  type: GUEST_HISTORY_SEARCH_FAILURE,
  payload,
})

export const guestHistoryReset = (): GuestHistoryResetAction => ({
  type: GUEST_HISTORY_RESET,
})

